import {
  AUTHORIZE_TOOL_PROVIDER_ROUTE,
  DISCONNECT_TOOL_PROVIDER_CONNECTION_ROUTE,
  GET_TOOL_PROVIDER_AUTH_STATUS_ROUTE,
  GET_TOOL_PROVIDER_CONNECTION_USAGE_ROUTE,
  GET_TOOL_PROVIDER_HEALTH_ROUTE,
  GET_TOOL_PROVIDER_TOOL_SCHEMA_ROUTE,
  LIST_TOOL_PROVIDERS_ROUTE,
  LIST_TOOL_PROVIDER_CONNECTIONS_ROUTE,
  LIST_TOOL_PROVIDER_CONNECTION_FIELDS_ROUTE,
  LIST_TOOL_PROVIDER_TOOLKITS_ROUTE,
  LIST_TOOL_PROVIDER_TOOLS_ROUTE,
  TOOL_PROVIDER_CONNECTION_STATUS_ROUTE,
  UPDATE_TOOL_PROVIDER_CONNECTION_ROUTE,
} from '../../handlers/tool-providers';

export const TOOL_PROVIDER_ROUTES = [
  LIST_TOOL_PROVIDERS_ROUTE,
  LIST_TOOL_PROVIDER_TOOLKITS_ROUTE,
  LIST_TOOL_PROVIDER_TOOLS_ROUTE,
  GET_TOOL_PROVIDER_TOOL_SCHEMA_ROUTE,
  AUTHORIZE_TOOL_PROVIDER_ROUTE,
  GET_TOOL_PROVIDER_AUTH_STATUS_ROUTE,
  TOOL_PROVIDER_CONNECTION_STATUS_ROUTE,
  LIST_TOOL_PROVIDER_CONNECTIONS_ROUTE,
  LIST_TOOL_PROVIDER_CONNECTION_FIELDS_ROUTE,
  DISCONNECT_TOOL_PROVIDER_CONNECTION_ROUTE,
  UPDATE_TOOL_PROVIDER_CONNECTION_ROUTE,
  GET_TOOL_PROVIDER_CONNECTION_USAGE_ROUTE,
  GET_TOOL_PROVIDER_HEALTH_ROUTE,
] as const;
